import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initDatadogRum } from "./datadog.ts";

initDatadogRum();
createRoot(document.getElementById("root")!).render(<App />);
